<template>
    <div class="z-10">
        <PageComponent 
            :loader="loader" @showLoader="showLoader" @hideLoader="hideLoader"
            :addButtonLabel="addButtonLabel"
            @handleAddNew="addNewAttendance"
            :searchFilters="searchFilters"
            :dropdownOptions="dropdownOptions"
            @handleDynamicOption="handleDynamicOption"
            @searchPage="searchAttendances"
            @resetFilters="resetFilters"
            @removeItem="removeAttendance"
            @removeSelectedItems="removeAttendances"
            @printList="printattendanceList"
            :addingRight="addingRight"
            :removingRight="removingRight"
            :rightsModule="rightsModule"
            :columns="tableColumns"
            :rows="attendanceList"
            :actions="actions"
            :showTotals=false
            :idField="idField"
            @handleSelectionChange="handleSelectionChange"
            @handleActionClick="handleActionClick"
            :count="propCount"
            :currentPage="currentPage"
            :result="propArrLen"
            @loadPrev="loadPrev"
            @loadNext="loadNext"
            @firstPage="firstPage"
            @lastPage="lastPage"
            :showNextBtn="showNextBtn"
            :showPreviousBtn="showPreviousBtn"
            :selectedValue="selectedValue"
            @selectSearchQuantity="selectSearchQuantity"
            :showDetails="showDetails"
            :detailsTitle="detailsTitle"
            @hideDetails="hideDetails"
        >
        </PageComponent>
    </div>
</template>

<script>
import axios from "axios";
import { ref, computed, onMounted, onBeforeMount, watch} from 'vue';
import PageComponent from '@/components/PageComponent.vue';
import MovableModal from '@/components/MovableModal.vue';
import DynamicForm from '../NewDynamicForm.vue';
import { useStore } from "vuex";
import { useToast } from "vue-toastification";
import { useDateFormatter } from '@/composables/DateFormatter';
import Swal from 'sweetalert2';

export default{
    name: 'Attendance',
    components:{
        PageComponent, MovableModal,DynamicForm
    },
    setup(){
        const store = useStore();     
        const toast = useToast();
        const { getYear } = useDateFormatter();
        const { getMonth } = useDateFormatter();
        const current_date = new Date();
        const loader = ref('none');
        const modal_loader = ref('none');
        const app_modal_loader = ref('none');
        const idField = 'attendance_id';
        const addButtonLabel = ref('New Attendance');
        const addingRight = ref('Adding Employee Attendance');
        const removingRight = ref('Deleting Employee Attendance');
        const rightsModule = ref('HR');
        const submitButtonLabel = ref('Add');
        const brnComponentKey = ref(0);
        const projComponentKey = ref(0);
        const modal_top = ref('200px');
        const modal_left = ref('500px');
        const modal_width = ref('30vw');
        const selectedIds = ref([]);
        const attendanceList = ref([]);
        const propResults = ref([]);
        const propArrLen = ref(0);
        const propCount = ref(0);
        const pageCount = ref(0);
        const selectedValue = ref(50);
        const showDetails = ref(false);
        const currentPage = ref(1);
        const showNextBtn = ref(false);
        const showPreviousBtn = ref(false);
        const propModalVisible = ref(false);
        const flex_basis = ref('');
        const flex_basis_percentage = ref('');
        const displayButtons = ref(true);
        const errors = ref([]);
        const projectID = ref(null);
        const attendanceID = ref(null);
        const branchID = ref('');
        const projectArray = computed(() => store.state.Projects.projectArr);
        const branchArray = computed(() => store.state.Branches.branchArr);
        const showModal = ref(false);
        const tableColumns = ref([
            {type: "checkbox"},
            {label: "Date", key: "date"},
            {label: "Count", key: "employee_count"},
            {label: "Project", key:"project_name"},
            {label: "Branch", key:"branch_name"},
            
        ])
        const showTotals = ref(true);
        const actions = ref([
            {name: 'view', icon: 'fa fa-file-pdf-o', title: 'View Attendance', rightName: 'View Employee Attendance'},
            {name: 'delete', icon: 'fa fa-trash', title: 'Delete Attendance', rightName: 'Deleting Employee Attendance'},
        ])
        const companyID = computed(()=> store.state.userData.company_id);
        const fetchProjects = async() =>{
            await store.dispatch('Projects/fetchProjects', {company:companyID.value})
        };
        const handleSearchProject = async(option) =>{
            await store.dispatch('Projects/handleSelectedProject', option)
            projectID.value = store.state.Projects.projectID;
        };
        const clearSearchProject = async() =>{
            await store.dispatch('Projects/updateState', {projectID: ''});
            projectID.value = ""
        };
        const fetchBranches = async() =>{
            await store.dispatch('Branches/fetchBranches', {company:companyID.value})
        };
        const handleSearchBranch = async(option) =>{
            await store.dispatch('Branches/handleSelectedBranch', option)
            branchID.value = store.state.Branches.branchID;
        };
        const clearSearchBranch = async() =>{
            await store.dispatch('Branches/updateState', {branchID: ''});
            branchID.value = ""
        };
        const from_date_search = ref("");
        const to_date_search = ref("");
        const searchFilters = ref([

            {type:'date', placeholder:"From Date...", value: from_date_search, width:36, title: "Date From Search"},
            {type:'date', placeholder:"To Date...", value: to_date_search, width:36, title: "Date To Search"},
            {
                type:'search-dropdown', value: projectArray, width:48,
                selectOptions: projectArray, optionSelected: handleSearchProject,
                searchPlaceholder: 'Project...', dropdownWidth: '300px',
                clearSearch: clearSearchProject(), componentKey: projComponentKey
            },
            {
                type:'search-dropdown', value: branchArray, width:48,
                selectOptions: branchArray, optionSelected: handleSearchBranch,
                searchPlaceholder: 'Branch...', dropdownWidth: '300px',
                clearSearch: clearSearchBranch(), componentKey: brnComponentKey
            },
        ]);
        const handleSelectionChange = (ids) => {
            selectedIds.value = ids;
        };
        
        const formFields = ref([]);
        const updateFormFields = () =>{
            formFields.value = [
            ]
        };

        const handleReset = async() =>{
            for(let i=0; i < formFields.value.length; i++){
                formFields.value[i].value = '';
            }
            projComponentKey.value += 1;
            brnComponentKey.value += 1;
            projectID.value = '';
        }
        
        const showModalLoader = () =>{
            modal_loader.value = "block";
        }
        const hideModalLoader = () =>{
            modal_loader.value = "none";
        }


        const removeAttendance = async() =>{
            if(selectedIds.value.length == 1){
                let formData = {
                    company: companyID.value,
                    attendance: selectedIds.value,
                }
                try{
                    const response = await store.dispatch('Attendances/deleteAttendance',formData)
                    if(response && response.status == 200){
                        toast.success("Attendance Removed Succesfully");
                        searchAttendances();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Attendance: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                    searchAttendances();
                }
            }else if(selectedIds.value.length > 1){
                toast.error("You have selected more than 1 Attendance") 
            }else{
                toast.error("Please Select An Attendance To Remove")
            }
        }
        const removeAttendances = async() =>{
            if(selectedIds.value.length){
                let formData = {
                    company: companyID.value,
                    attendance: selectedIds.value,
                }

                try{
                    const response = await store.dispatch('Attendances/deleteAttendance',formData)
                    if(response && response.msg == "Success"){
                        toast.success("Attendance(s) Removed Succesfully");
                        searchAttendances();
                    }
                }
                catch(error){
                    console.error(error.message);
                    toast.error('Failed to remove Attendances: ' + error.message);
                }
                finally{
                    selectedIds.value = [];
                    searchAttendances();
                }
            }else{
                toast.error("Please Select An Attendance To Remove")
            }
        }
        const showLoader = () =>{
            loader.value = "block";
        }
        const hideLoader = () =>{
            loader.value = "none";
        }
        const searchAttendances = () =>{
            showLoader();
            showNextBtn.value = false;
            selectedIds.value = [];
            showPreviousBtn.value = false;
            let formData = {
                date_from: from_date_search.value,
                date_to: to_date_search.value,
                branch: branchID.value,
                project: projectID.value,
                company: companyID.value,
                page_size: selectedValue.value
            } 
   
            axios
            .post(`api/v1/attendances-search/?page=${currentPage.value}`,formData)
            .then((response)=>{
                attendanceList.value = response.data.results;
                store.commit('Attendances/LIST_ATTENDANCES', attendanceList.value)
                propResults.value = response.data;
                propArrLen.value = attendanceList.value.length;
                propCount.value = propResults.value.count;
                pageCount.value = Math.ceil(propCount.value / selectedValue.value);
                if(response.data.next){
                    showNextBtn.value = true;
                }
                if(response.data.previous){
                    showPreviousBtn.value = true;
                }
            })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        };
        const selectSearchQuantity = (newValue) =>{
            selectedValue.value = newValue;
            searchAttendances(selectedValue.value);
        };
        const resetFilters = () =>{
            currentPage.value = 1;
            selectedValue.value = 50;
            from_date_search.value= "";
            to_date_search.value = "";
            projComponentKey.value += 1;
            brnComponentKey.value += 1;
            projectID.value = "";
            branchID.value = "";
            searchAttendances();
        }
        const loadPrev = () =>{
            if (currentPage.value <= 1){
                currentPage.value = 1;
            }else{
                currentPage.value -= 1;
            }
            
            searchAttendances();
            // scrollToTop();
        }
        const loadNext = () =>{
            if(currentPage.value >= pageCount.value){
                currentPage.value = pageCount.value;
            }else if(currentPage.value < pageCount.value){
                currentPage.value += 1;
            }
            
            searchAttendances();
            // scrollToTop(); 
        }
        const firstPage = ()=>{
            currentPage.value = 1;
            searchAttendances();
            // scrollToTop();
        }
        const lastPage = () =>{
            currentPage.value = pageCount.value;
            searchAttendances();
            // scrollToTop();
        }
        const addNewAttendance = async() =>{
            await store.dispatch('Attendances/updateState',{emplAttendances: []})
            store.commit('pageTab/ADD_PAGE', {'HR':'Employee_Attendances'})
            store.state.pageTab.hrActiveTab = 'Employee_Attendances';

        }
        const handleActionClick = async(rowIndex, action, row) =>{
            if(action == 'delete'){
                const attendanceID = [row['attendance_id']];
                let formData = {
                    company: companyID.value,
                    attendance: attendanceID,
                }
                await store.dispatch('Attendances/deleteAttendance',formData).
                then(()=>{
                    searchAttendances();
                })
                
            }else if(action == 'view'){
                const attendanceID = row['attendance_id'];
                await store.dispatch('Attendances/updateState',{attendanceID: attendanceID})
                store.commit('pageTab/ADD_PAGE', {'HR':'Attendance_Employees'})
                store.state.pageTab.hrActiveTab = 'Attendance_Employees';
            }
        }
        const hideDetails = async() =>{
            showDetails.value = false;
        };

        const dropdownOptions = ref([
            
        ]);
        const handleDynamicOption = (option) =>{

        };
        const printattendanceList = () =>{
            showLoader();

            let formData = {
                date_from: from_date_search.value,
                date_to: to_date_search.value,
                branch: branchID.value,
                project: projectID.value,
                company: companyID.value,
            } 
   
            axios
            .post("api/v1/export-attendances-pdf/", formData, { responseType: 'blob' })
                .then((response)=>{
                    if(response.status == 200){
                       
                    }
                })
            .catch((error)=>{
                console.log(error.message);
            })
            .finally(()=>{
                hideLoader();
            })
        }
        onBeforeMount(()=>{
            searchAttendances();
            fetchProjects();
            fetchBranches();
        })
        return{
            showTotals, searchAttendances,resetFilters, addButtonLabel, searchFilters, tableColumns, attendanceList,
            currentPage,propResults, propArrLen, propCount, pageCount, showNextBtn, showPreviousBtn,
            loadPrev, loadNext, firstPage, lastPage, idField, actions, handleActionClick,
            submitButtonLabel, showModal, addNewAttendance, showLoader, loader, hideLoader, modal_loader, modal_top, modal_left, modal_width,displayButtons,
            showModalLoader, hideModalLoader, formFields, handleSelectionChange, flex_basis,flex_basis_percentage,
            removeAttendance, removeAttendances, dropdownOptions, handleDynamicOption,addingRight,removingRight,rightsModule,printattendanceList,
            selectSearchQuantity,selectedValue,showDetails,hideDetails,
        }
    }
};
</script>

<style scoped>
.tabs {
    display: flex;
    border-bottom: 1px solid #ccc;
}
.tab {
    padding: 2px 20px 2px 20px;
    cursor: pointer;
}

.tab.active {
    border-bottom: 2px solid #000;
}

.tab-content {
    padding: 1px;
}</style>